import { useNetworkScope } from './useNetworkScope'

// The brand a page's data should be scoped to when internal staff have opened
// a client's workspace (/portal/:brandSlug/*), else null.
//
// Internal staff see the client's FULL rail inside a workspace — Dashboard,
// Production, Content, Experts — but those pages fetch by brand id, and staff
// have no brand membership of their own. Without this they'd fall through to
// the all-brands endpoints and show internal-wide data under a client's
// heading, which is worse than not showing the tabs at all.
//
// It returns null rather than a brand id outside a workspace so each call site
// keeps its OWN existing rule for the non-workspace case. Those rules differ —
// some check only "does the viewer have a brand", others also exclude internal
// usertypes — and collapsing them here would quietly change who gets scoped on
// pages that have nothing to do with workspaces.
//
//   const workspaceBrandId = useWorkspaceBrandId()
//   const effectiveBrandId = workspaceBrandId || <the page's existing rule>
export function useWorkspaceBrandId(): number | null {
  const { brandId, inWorkspace } = useNetworkScope()
  return inWorkspace && brandId ? brandId : null
}
